import React from 'react';
import { Form, Col, Row, InputNumber, Typography, Table, Button, Select, Tooltip  } from 'antd';
import '../App.css';
import 'antd/dist/antd.css'; 
import 'moment/locale/es';
import { InfoCircleOutlined} from '@ant-design/icons';
//Seleccionar regimenes en los que aportaste
const {Item} = Form;

function App() {

  const {Text}=Typography;
  const {Option}=Select;
  const columns=[
    {
      title:"Categoria",
      dataIndex:"categoria",
      key:"categoria"
    },
    {
      title:"Años",
      dataIndex:"años",
      key:"años"
    },
    {
      title:"Meses",
      dataIndex:"meses",
      key:"meses"
    },
    {
      title:"Acciones",
      dataIndex:"acciones",
      key:"acciones",
      render: fila => <> <Button type="primary">Editar</Button> {"   "} <Button type="danger">Eliminar</Button> </>
    }
  ];

  const data=[
    {
      key:"1",
      categoria:"I",
      años:15,
      meses:3
    },
    {
      key:"2",
      categoria:"V",
      años:2,
      meses:10
    },
    {
      key:"3",
      categoria:"J",
      años:7,
      meses:11
    },
    {
      key:"4",
      categoria:"H",
      años:8,
      meses:3
    },
  ]

  const layout = {
    labelCol: {
      span: 8,
    }
  };

  return (

    <div>

     <Row>
        <Col xs={1} sm={1} md={2} lg={4} ></Col>

        <Col xs={22} sm={22} md={20} lg={16} >

          <Form name="formulario" {...layout}>                                                  
                                    
              <Item name="aportes" label="Rel. de dependencia" rules={[{required:true,message:"Por favor ingrese los Años y Meses "}]}> <InputNumber placeholder='Años'  name='AporteAños' ></InputNumber> <InputNumber style={{ marginLeft: 8 }} placeholder='Meses' name='AporteMeses'></InputNumber> </Item>
              <Item name="aportesIndependiente" label="Independiente"  rules={[{required:true,message:"Por favor ingrese los aportes Años y Meses "}]}> <InputNumber placeholder='Años'  name='AporteIAños' ></InputNumber> <InputNumber style={{ marginLeft: 8 }} placeholder='Meses' name='AporteIMeses'></InputNumber> </Item>
              <Item name="aportesCoincidentes" label="Coincidentes"  rules={[{required:true,message:"Por favor ingrese los Años y Meses "}]}> <InputNumber placeholder='Años'  name='AporteAAños' ></InputNumber> <InputNumber style={{ marginLeft: 8 }} placeholder='Meses' name='AporteAMeses'></InputNumber> </Item>
              <span className="required">* </span><Text  strong> CATEGORIAS AUTONOMO</Text><Tooltip placement="top" title="Texto de ayuda"> <InfoCircleOutlined /> </Tooltip><br/><br/>              
                <Item name="autonomo" labelCol={{ span: 24 }} wrapperCol={{ span: 24 }}  label="" rules={[{required:true,message:"Por favor ingrese asd"}]}>
                  <Select style={{ width: 200, marginTop: 8 }}  placeholder="Categoria de autónomo">
                    <Option value="1">I  </Option>
                    <Option value="2">II </Option>
                    <Option value="3">III</Option>
                    <Option value="4">IV </Option>
                    <Option value="5">V  </Option>
                    <Option value="A">A  </Option>
                    <Option value="B">B  </Option>
                    <Option value="C">C  </Option>
                    <Option value="D">D  </Option>
                    <Option value="E">E  </Option>
                    <Option value="F">F  </Option>
                    <Option value="G">G  </Option>
                    <Option value="H">H  </Option>
                    <Option value="I">I  </Option>
                    <Option value="J">J  </Option>
                  </Select>   
                  <InputNumber style={{ marginLeft: 8 , marginTop: -3}} placeholder='Años'  name='AporteCAños' ></InputNumber>          
                  <InputNumber style={{ marginLeft: 8 , marginTop: -3}} placeholder='Meses' name='AporteCMeses'></InputNumber>                  
                  <Button style={{ marginLeft: 8 , marginBottom:5}} type="primary" >AGREGAR</Button>
                  
                  <Table columns={columns} dataSource={data} size="small" bordered/>                       
                </Item>


          </Form>

        </Col>

        <Col xs={1} sm={1} md={2} lg={4} ></Col>
     </Row>
    </div>

);}

export default App;